import { useDisclosure } from '@chakra-ui/hooks';
import { Container } from '@chakra-ui/react';
import { NextPage } from 'next';

import { Section } from '@/components/ui/core/Section/Section';
import { LibrariansHeader } from '@/components/ui/features/librarians/LibrariansHeader/LibrariansHeader';
import { LibrariansOriginals } from '@/components/ui/features/librarians/LibrariansOriginals/LibrariansOriginals';
import { LibrariansResourceCenter } from '@/components/ui/features/librarians/LibrariansResourceCenter/LibrariansResourceCenter';
import { LibrariansScience } from '@/components/ui/features/librarians/LibrariansScience/LibrariansScience';
import { LibrariansSeo } from '@/components/ui/features/librarians/LibrariansSeo/LibrariansSeo';
import { LibrariansSubscription } from '@/components/ui/features/librarians/LibrariansSubscription/LibrariansSubscription';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { ContactUs } from '@/components/ui/shared/sections/ContactUs/ContactUs';
import { AccessFrom } from '@/enums/AccessFrom';

const LibrariansPage: NextPage = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Layout navigationVariant="default">
      <LibrariansSeo />
      <LibrariansHeader onOpen={onOpen} />
      <Section overflow="hidden">
        <Container px={{ base: 5, md: 10, lg: 5 }}>
          <LibrariansScience />
          <LibrariansOriginals />
          <LibrariansResourceCenter />
          <LibrariansSubscription />
        </Container>
      </Section>
      <ContactUs isOpen={isOpen} onClose={onClose} onOpen={onOpen} />
    </Layout>
  );
};

export default LibrariansPage;
